import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-tv-2-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg tracking-wide text-foreground-950">51动漫</span>
              <span className="text-[10px] tracking-widest text-foreground-500">
                ANIME NEW SEASON
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#schedule"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-calendar-line mr-1.5" />
              本周番剧表
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="grid grid-cols-2 gap-1 px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}